/* eslint-disable */
import React from 'react'
import SprayPoint from './SprayPoint'

export default function SprayChart({
    settings,
    isFinished,
    chartOptions = {},
}) {
    const sprayData = settings.data

    return (
        <>
            {sprayData.map((d, i) => {
                const coords = { x: d.x, y: d.y }
                // Stagger z plane to prevent mesh bug in three.js and add 2 to fix infield bug issue
                const z = i / 100 + 2

                return (
                    <SprayPoint
                        key={`spray_${i}`}
                        settings={settings}
                        coords={coords}
                        legendField={d[chartOptions.legendType]}
                        z={z}
                        lastUpdate={sprayData.length === i + 1}
                        isFinished={(finishedUpdate) => {
                            isFinished(finishedUpdate)
                        }}
                        chartOptions={chartOptions}
                    />
                )
            })}
        </>
    )
}
